import React from 'react'
import PropTypes from 'prop-types'
import {
  View,
  ScrollView,
} from 'react-native'
import {
  VFText,
} from '@vfgroup-oneplatform/foundation/Components'
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'
import ContentManager from '@vfgroup-oneplatform/foundation/ContentManager'


import Collapsible from '../Collapsible'

import Bundle from '../Bundle/Bundle'

import { getThemeImages } from '../../Themes'

import styles from './BundleList.Styles'
import VfText from '../VfText'



function BundleList({
  isLoading = false,
  selectedOffer,
  setSelectedOffer,
  offers,
  showHeader,
  isPurchase,
  containerStyles,
  offerCardStyleContainer,
  bundleProps,
  isTV,
  ...rest
}) {

  const theme = useTheme()

  const themeImages = getThemeImages(theme.name)

  const renderHeader = () => {
    if (!showHeader) { return null }
    return (
      <View style={styles.showHeaderStyle}>
        <VfText
          i18nKey="renewals_title"
          style={styles.stepTitle}
          isLoading={isLoading}
          color={theme.colors.textColor}
          loadingBackgroundColor={theme.colors.shimmerCenterColor}
          loadingForegroundColor={theme.colors.shimmerEdgesColor}
        />
        <VfText
          i18nKey="renewals_chosen_plan"
          style={styles.stepDesc}
          isLoading={isLoading}
          color={theme.colors.textColorTwo}
          loadingBackgroundColor={theme.colors.shimmerCenterColor}
          loadingForegroundColor={theme.colors.shimmerEdgesColor}
        />
      </View >
    )
  }

  const renderDescription = ({ period = '', desc = '' } = {}) => {
    return (
      <View style={styles.descOfferContainer}>
        <View style={styles.offerPriceContainer}>
          <VFText
            i18nKey={desc}
            style={styles.offerPrice}
          />
          {!!desc && !!period && <VFText
            i18nKey={' / ' + ContentManager.translate(period)}
            style={styles.offerPeriod(theme)}
          />}
        </View>
        {/* <VFText
          i18nKey={offer?.original_price ?? ''}
          style={styles.offerOriginalPrice}
        /> */}
      </View>
    )
  }


  const iconTypes = {
    uploadspeed: themeImages.upload,
    fup: themeImages.wifi,
    downloadspeed: themeImages.internet,
    document: themeImages.document,
    tv: themeImages.tv,
  }


  return (
    <ScrollView
      showsVerticalScrollIndicator={false}
      contentContainerStyle={[styles.scrollviewContainer, containerStyles]}
      nestedScrollEnabled={true}
    >
      {renderHeader()}
      <div style={{ overflow: 'scroll' }}>
        <Collapsible
          items={offers?.map(offer => ({
            icon: offer?.icon || (isTV ? themeImages.tv_bundle : themeImages.ic_bundle),
            title: offer?.title || '',
            desc: () => renderDescription(offer),
            content: <Bundle
              key={offer?.id}
              offer={offer}
              buttonTitle="renewals_get_bundle_button"
              isLoading={isLoading}
              iconTypes={iconTypes}
              theme={theme}
              isTV={isTV}
              {...bundleProps}
            />,
            // isOpend: true,
            isLoading: isLoading,
            card: {
              shadowLevel: 'low',
              // title: offer?.recomandation_type ? 'renewals_recommended_offer' : undefined,
            },
            style: {
              //             borderWidth: 1,
              //             borderColor: Colors.blue_two,
              borderRadius: 7,
            },
          }))}
          titleStyle={styles.titleOfferStyle(theme)}
          // isContentLoading={isContentLoading}
          selected={offers?.findIndex?.(el => JSON.stringify(el) === JSON.stringify(selectedOffer))}
          setSelected={el => {
            // setSelectedOffer(offers[el])
          }}
          withCard
          cardStyle={[styles.offerCardStyle, offerCardStyleContainer]}
          theme={theme}
          {...rest}
        />
      </div>
    </ScrollView >
  )
}

BundleList.propTypes = {
  selectedOffer: PropTypes.number,
  setSelectedOffer: PropTypes.func,
  offers: PropTypes.array,
  onClose: PropTypes.func,
  navigateToRenewal: PropTypes.func,
  showHeader: PropTypes.bool,
  isPurchase: PropTypes.bool,
  containerStyles: PropTypes.any,
  bundleProps: PropTypes.shape({
    offer: PropTypes.object.isRequired,
    showButton: PropTypes.bool,
    buttonTitle: PropTypes.string,
    onButtonPress: PropTypes.func,
  }),
  offerCardStyleContainer: PropTypes.any,
  theme: PropTypes.object,
  isTV: PropTypes.bool,
}

BundleList.defaultProps = {
  showHeader: false,
  isTV: false
}

export default BundleList
